import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <>
      <header data-section-id="32202" className={cn("fixed top-0 left-0 z-50 w-full transition-all duration-300 ease-in-out border-b", isScrolled ? "bg-background/80 backdrop-blur-md border-transparent shadow-md" : "bg-background border-accent/20")}>
        <div className="container mx-auto px-4 h-20 flex items-center justify-center md:justify-between">
          {}
          <div className="flex-shrink-0">
            <Link to="/HomePage" className="block">
              <img src="http://clint.websiteshop.au/wp-content/uploads/2026/03/Clint-Logo-1.png" alt="Clint's Coastal Painting and Decorating" className="h-16 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div className="hidden md:flex flex-1 justify-center">
            {loading ? <div className="flex gap-6">
                {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-20 bg-muted animate-pulse rounded-md" data-index={i} />)}
              </div> : <NavigationMenu>
                <NavigationMenuList className="gap-8">
                  {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                      <NavigationMenuLink asChild>
                        <Link to={item.href || "#"} className="group relative text-sm font-semibold tracking-wide text-foreground transition-colors hover:text-primary py-2 block">
                          {item.label}
                          <span className="absolute bottom-0 left-0 h-[2px] w-full origin-bottom-right scale-x-0 bg-accent transition-transform duration-300 group-hover:origin-bottom-left group-hover:scale-x-100" />
                        </Link>
                      </NavigationMenuLink>
                    </NavigationMenuItem>)}
                </NavigationMenuList>
              </NavigationMenu>}
          </div>

          {}
          <div className="hidden md:flex items-center gap-4">
            <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold uppercase tracking-widest shadow-lg transition-all duration-300">
              <Link to="/ContactPage">Get a Quote</Link>
            </Button>
          </div>

          {}
          <div className="md:hidden">
            <Button variant="ghost" size="icon" className="text-foreground hover:text-primary hover:bg-muted/50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {}
        {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-background border-b border-border shadow-xl animate-in slide-in-from-top-5 z-40">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-4">
              <nav className="flex flex-col space-y-2">
                {loading ? <div className="space-y-3">
                    {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-full bg-muted animate-pulse rounded-md" data-index={i} />)}
                  </div> : menuItems.map((item, i) => <div key={item.id} data-index={i}>
                      <Link to={item.href || "#"} className="block text-lg font-medium text-foreground hover:text-primary py-3 border-b border-border/40 last:border-0 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                        {item.label}
                      </Link>
                    </div>)}
              </nav>
              <div className="pt-2">
                <Button asChild className="w-full bg-primary text-primary-foreground h-12 text-base font-semibold uppercase tracking-widest">
                  <Link to="/ContactPage" onClick={() => setIsMobileMenuOpen(false)}>
                    Get a Quote
                  </Link>
                </Button>
              </div>
            </div>
          </div>}
      </header>
      <div className="h-20" aria-hidden="true" />
    </>;
}
export default function Header() {
  return <section id="coastal-navigation" className="light bg-background text-foreground relative">
      <MenuProvider menu_id="2">
        <HeaderContent />
      </MenuProvider>
    </section>;
}